// src/components/profile/AvatarUpload.js
import { useState, useRef } from 'react';

const AvatarUpload = ({ currentAvatar, onUpload, loading }) => {
  const [preview, setPreview] = useState(currentAvatar);
  const [uploading, setUploading] = useState(false);
  const fileInputRef = useRef(null);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Validate file type
    if (!file.type.startsWith('image/')) {
      alert('Please select an image file');
      return;
    }

    // Validate file size (5MB)
    if (file.size > 5 * 1024 * 1024) {
      alert('Image size must be less than 5MB');
      return;
    }

    // Create preview
    const reader = new FileReader();
    reader.onloadend = () => {
      setPreview(reader.result);
    };
    reader.readAsDataURL(file);

    // Upload file
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('avatar', file);
      await onUpload(formData);
    } catch (error) {
      console.error('Upload error:', error);
      setPreview(currentAvatar); // Reset preview on error
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="flex items-center space-x-4">
      <div className="relative">
        {preview ? (
          <img
            src={preview}
            alt="Avatar preview"
            className="w-24 h-24 rounded-full object-cover border-4 border-shayek-light-200 dark:border-shayek-dark-300"
          />
        ) : (
          <div className="w-24 h-24 rounded-full bg-gradient-to-br from-shayek-primary to-shayek-primary-600 flex items-center justify-center text-white text-2xl font-bold border-4 border-shayek-light-200 dark:border-shayek-dark-300">
            U
          </div>
        )}
        {uploading && (
          <div className="absolute inset-0 bg-black bg-opacity-50 rounded-full flex items-center justify-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-white"></div>
          </div>
        )}
      </div>
      <div>
        <input
          ref={fileInputRef}
          type="file"
          accept="image/*"
          onChange={handleFileChange}
          className="hidden"
        />
        <button
          type="button"
          onClick={() => fileInputRef.current?.click()}
          disabled={uploading || loading}
          className="px-4 py-2 bg-shayek-light-100 dark:bg-shayek-dark-200 text-shayek-light-700 dark:text-shayek-dark-700 rounded-lg hover:bg-shayek-light-200 dark:hover:bg-shayek-dark-300 focus:outline-none focus:ring-2 focus:ring-shayek-primary focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
        >
          {uploading ? 'Uploading...' : 'Change Avatar'}
        </button>
        <p className="text-xs text-shayek-light-600 dark:text-shayek-dark-600 mt-1">
          Max 5MB, JPG/PNG/GIF
        </p>
      </div>
    </div>
  );
};

export default AvatarUpload;

